// Wann läuft eine Tour — und was sagt der Streifen dann?
//
// Bewusst OHNE Supabase, React oder sonst etwas: Diese beiden Entscheidungen
// sind der ganze Verstand des Tour-Streifens, und sie müssen prüfbar sein, ohne
// dass ein Browser läuft. Der Prüfer lädt genau diese Datei (verify-tour-
// streifen.mjs) — keine nachgebaute Kopie, sonst prüft er seine eigene Meinung.

export interface TourZeile {
  id: string;
  tour_date: string;
  status: string;
  packlist_started_at: string | null;
  packlist_confirmed_at: string | null;
}

/**
 * Welche der offenen Touren gehört in den Streifen — oder keine?
 *
 * Drei Bedingungen, und jede hat ihren Grund:
 *
 *  • Der Tag ist gekommen. Für JEDEN Liefertag steht längst eine geplante Tour
 *    in der Datenbank; nähme man die auch, leuchtete der Streifen immer und
 *    niemand läse ihn noch.
 *  • Sie ist nicht abgeschlossen. Danach gibt es nichts fortzusetzen.
 *  • Es hat jemand angefangen — Packliste begonnen oder Tour gestartet. Vorher
 *    ist es keine laufende Arbeit, sondern nur ein Plan.
 *
 * Kommen mehrere in Frage, gewinnt die von heute: Eine liegengebliebene Tour
 * von gestern darf die aktuelle nicht verdecken. Gibt es heute keine, bleibt die
 * jüngste angefangene stehen — auch die will noch zu Ende gebracht werden.
 */
export function waehleLaufendeTour(touren: TourZeile[], heute: string): TourZeile | null {
  const begonnen = touren
    .filter((t) => t.tour_date <= heute)
    .filter((t) => t.status !== "finished")
    .filter((t) => t.status === "active" || !!t.packlist_started_at)
    .sort((a, b) => b.tour_date.localeCompare(a.tour_date));

  return begonnen.find((t) => t.tour_date === heute) ?? begonnen[0] ?? null;
}

/** Beladen oder Fahren — solange die Packliste offen ist, wird geladen. */
export function phaseVon(t: TourZeile): "beladen" | "fahren" {
  return t.packlist_confirmed_at ? "fahren" : "beladen";
}

/**
 * Der Fortschritt in Worten. Beim Beladen zählt, was schon im Auto ist; beim
 * Fahren, was noch aussteht — das ist die Zahl, die den Fahrer interessiert.
 */
export function streifenText(phase: "beladen" | "fahren", fertig: number, gesamt: number): string {
  if (phase === "beladen") {
    return gesamt ? `${fertig} von ${gesamt} im Auto` : "Packliste offen";
  }
  const offen = Math.max(0, gesamt - fertig);
  if (!gesamt) return "keine Kunden auf der Tour";
  return offen ? `noch ${offen} von ${gesamt} Kunden` : "alle Kunden erledigt";
}
